import * as React from 'react';
import {
  NavItem,
  NavLink,
  Button
} from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom'
import { INavBarActions, IOpenMenuItem } from '../hooks/useNavState';
import NavigationLink from './NavigationLink';
import { MobileCollapse } from './MobileCollapse';
import { isNavigationActive } from '../hooks/useIsRouteActive';
import { useNavBar } from 'src/modules/Routing/hooks/navBars/useNavBar';
import { ISideBar } from 'src/modules/Routing/types';

interface IMobileViewProps {
  isOpenMenuItem: Partial<IOpenMenuItem>;
  actions: INavBarActions;
}

const checkMobileCollapse = (collapseRoutes: ISideBar[]) => {
  const mobileRoutes = collapseRoutes && collapseRoutes.filter(route => !route.hideOnMobile);
  return mobileRoutes.length > 0;
}

const MobileView: React.SFC<IMobileViewProps> = (props) => {
  const { actions, isOpenMenuItem } = props;
  const [routes] = useNavBar();
  const navigations = [...routes.body, ...routes.settings];
  const isActive = isNavigationActive();
  return (
    <div className="mobile-container">
      {navigations.map((navModule, i) => {
        const hasCollapseItems = checkMobileCollapse(navModule.sidebar || []);
        return (
          <NavItem key={navModule.module}>
            <div className="mobile-navitem">
              <div className="menu-item-composed">
                <NavigationLink
                  isActive={isActive(navModule.route, i)}
                  handleClick={actions.toggle}
                  routePath={navModule.route}
                  navTitle={navModule.module}
                />
                {hasCollapseItems &&
                  <Button color="primary" onClick={() => actions.toggleMenuItems(navModule.module)}>
                    <i className={`rotate ${isOpenMenuItem[navModule.module] && 'down'} fa fa-chevron-right`} aria-hidden="true" />
                  </Button>}
              </div>
              {hasCollapseItems &&
                <MobileCollapse
                  toggle={actions.toggle}
                  handleOpen={isOpenMenuItem[navModule.module]}
                  mobileRoutes={navModule.sidebar || []}
                />}
            </div>
          </NavItem>
        )
      })}
      <NavItem>
        <div className="mobile-navitem">
          <div className="menu-item-composed">
            <NavLink to="#" onClick={actions.logout} tag={RRNavLink}>Logout</NavLink>
          </div>
        </div>
      </NavItem>
    </div>
  )
};

export default React.memo(MobileView);


// WEBPACK FOOTER //
// ./src/modules/Navigation/NavBar/components/MobileView.tsx